// Shared currency / number formatting helpers (en-GB).
// Note: returns the numeric part only — callers prepend "£" and any sign prefix
// so that absolute-value styling (e.g. "-£12.34") keeps working as before.
const moneyFormatter = new Intl.NumberFormat('en-GB', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const fmtMoney = (value) => moneyFormatter.format(Number(value) || 0);
